import React, { useEffect, useState } from "react";
import GoogleMapReact from "google-map-react";
import {
  GOOGLE_PACES_API_BASE_URL,
  GOOGLE_PLACES_API_KEY,
  RECURITER_PROFILE,
} from "../../../Service/service";
import { getData, postData } from "../../../Service/ApiMethod";
import MapBlackScreen from "./MapBlackScreen";

const MyListMap = (props) => {
  const [userProfileData, setUserProfileData] = useState()

  const mapview = props?.userMap?.data
  const singleUser = props?.userLocation
  const setUpdateChanges = props?.setUpdateChanges
  const updateChanges = props?.updateChanges
  // const singleCandidateData =props?.singleCandidateData

  console.log('Mapview data', mapview)
  console.log('userLocation', singleUser)

  const height = props?.mapHeight
  const defaultProps = {
    center: {
      lat: 28.6326784,
      lng: 77.2046848,
    },
    zoom: 11,
  };
  const handleApiLoaded = (map, maps) => {
    const obj = {
      map: map,
      maps: maps,
    };
    postData(obj, GOOGLE_PACES_API_BASE_URL)
      .then((res) => res.json())
      .then((res) => console.log(res));
  };
  
  console.log(props?.userMap);

  const apiIsLoaded = (map, maps) => {
    if(singleUser) {
      const directionsService = new window.google.maps.DirectionsService();
      const directionsRenderer = new window.google.maps.DirectionsRenderer();
      directionsRenderer.setMap(map);
      const origin = { lat: parseFloat(localStorage?.getItem("lat")), lng: parseFloat(localStorage?.getItem("lng")) };
      const destination = { lat: parseFloat(singleUser?.latitude) || parseFloat(singleUser?.seeker_details[0]?.latitude), lng: parseFloat(singleUser?.longitude) || parseFloat(singleUser?.seeker_details[0]?.longitude) };
      directionsService.route(
        {
          origin: origin,
          destination: destination,
          travelMode: window.google.maps.TravelMode.DRIVING
        },
        (result, status) => {
          if (status === window.google.maps.DirectionsStatus.OK) {
            directionsRenderer.setDirections(result);
          } else {
            console.error(`error fetching directions ${result}`);
          }
        }
      );
    }
  };

  useEffect(()=>{
    getData(RECURITER_PROFILE)
    .then(res => res.json())
    .then(data => {
      console.log('profile data', data.data)
      setUserProfileData(data.data)
    })
  },[])
  return (
    <div style={{ height: `${height?height:'100vh'}`, width: "100%", position:'relative' }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: GOOGLE_PLACES_API_KEY }}
        defaultCenter={defaultProps?.center}
        defaultZoom={defaultProps?.zoom}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={({ map, maps }) => apiIsLoaded(map, maps)}
      >
        <Users
          lat= { localStorage?.getItem("lat")}
          lng={localStorage?.getItem("lng")}
          image={userProfileData?.image}
        />

        {singleUser &&
         <SingleCandidate 
         lat= {singleUser?.latitude || (singleUser?.seeker_details[0]?.latitude)}
         lng={singleUser?.longitude || (singleUser?.seeker_details[0]?.longitude)}
         image = { singleUser?.applicant_profile_pic  ||  (singleUser?.seeker_details[0]?.image) }
         name = {singleUser?.first_name||  (singleUser?.seeker_details[0]?.first_name)}
        /> }
          
        

        {mapview?.map((item, i) => {
          return (
            <AnyReactComponentTwo
              key={i}
              lat={item?.latitude}
              lng={item?.longitude}
              image={item?.image}
              name={item?.first_name + " " + item?.last_name}
              item={item}
              setUpdateChanges={setUpdateChanges}
              updateChanges={updateChanges}
            />
          );
        })}
      </GoogleMapReact>
    </div>
  );
};

export default MyListMap;


const Users = (props) => {
  const text = props?.text
  const image = props?.image
  return(
  <>
  <div style={{textAlign:'center', width:'45px'}}>
      <img src={image ? image : "../images/msg1.png" } className="text-danger" alt="you" style={{width:'50px', height:'50px', borderRadius:'50%'}} />
      <h6 style={{color:'red', fontWeight:'800'}}>You</h6>
  </div>
  </>
)};

const SingleCandidate = (props) => {
  // const text = props?.text
  const candidateImg = props?.image
  const name =props?.name
  console.log('single candidate detailsssss', candidateImg, name)

  return(
  <>
  <div style={{textAlign:'center', width:'45px'}}>
    <img src={candidateImg } className="text-danger" alt="you" style={{width:'50px', height:'50px', borderRadius:'50%'}} />
    <h6 style={{color:'black', fontWeight:'800'}}>{name}</h6>
    </div>
  </>
)};

const AnyReactComponentTwo = (props) => {
  const [mapCandidateDetails, setMapCandidateDetails] = useState(false)

  const candidateDetails = props?.item
  // console.log('candidateDetails', candidateDetails)
  const setUpdateChanges=props?.setUpdateChanges
  const updateChanges = props?.updateChanges

return(
  <>
  <div>
    <div  style={{textAlign:'center', width:'45px'}} >
    <img
      alt="img"
      src={props?.image}
      style={{ height: "36px", width: "36px", borderRadius: "50%" }}
      onClick={(e)=>{
        e.stopPropagation()
        setMapCandidateDetails(true)
      }} 
    />
    <h4 className="text" style={{color:'black', fontWeight:'800'}}>{props?.name}</h4>
    </div>
    {mapCandidateDetails &&
    <>
      {/* <div className='blur-screen-full-area flex-center' style={{ position: 'inherit', top: '-100px', left:'0', zIndex: '999999999999999999999999', height: '100vh', background:'rgb(0, 0, 0, 0.7' }}> */}
        <MapBlackScreen candidateData={candidateDetails} setMapCandidateDetails={setMapCandidateDetails} setUpdateChanges={setUpdateChanges} updateChanges={updateChanges} />
      {/* </div> */}
    </>
  }
  </div>
</>
)
}